<template>
	<v-card flat class="comment-reply">
		<div class="d-flex flex-fill comment-reply__outer-box">
			<div class="comment-reply__info-box">
				<div class="comment-reply__title justify-space-between">
					<div
						class="comment-reply__title-box d-flex justify-space-between pl-8 pr-3"
						style="width: 100%"
					>
						<Avatar
							class="comment-reply__avatar"
							:size="40"
							:avatar="comment.authorAvatar"
						/>
						<div
							@click="toggleToUser"
							class="comment-reply__user-info-container cursor-pointer pl-3"
						>
							<span class="comment-card__user-name">
								{{ comment.authorName }}
							</span>
							<span class="comment-card__user-profile-row">
								{{ comment.user.second_profile_row }}
							</span>
						</div>
						<div
							class="comment-card__date"
							:class="{ 'no-ellipsis': !isOwnCurrentUserComment }"
						>
							<button
								@click="openDeleteModal"
								class="comment-card__date__button"
								:class="{
									'forum-card__meta-time__button--active': isModal,
								}"
								type="button"
								v-if="isOwnCurrentUserComment"
							>
								<Icon type="ellipsis" :size="24" color="var(--accent-color)" />
							</button>
							<div
								v-click-outside="closeModal"
								v-if="isModal"
								class="comment-card__date__button__reply-modal"
							>
								<Icon type="delete" :size="24" color="#FF3B30" />
								<button @click="handleDeleteComment(comment)" type="button">
									Delete
								</button>
							</div>
							{{ comment.date }}
						</div>
					</div>
				</div>
				<v-card-actions v-if="this.isAuthenticated && isEdit" class="pl-0">
					<CommentEditForm
						v-if="isEdit"
						:parent="parentComment"
						:comment="comment"
						v-click-outside="hideEditInput"
						@success="
							() => {
								this.isEdit = false
							}
						"
					/>
				</v-card-actions>

				<v-card-text
					v-if="!this.isEdit"
					class="pl-8 pr-3 py-4 comment-reply__content"
					v-html="contentFormateChangeMentions(comment.content)"
				></v-card-text>
				<v-divider />
				<div v-if="this.isAuthenticated" class="comment-card__likes-box">
					<div class="d-flex align-center">
						<span
							:class="
								isCurrentUserLike
									? 'comment-reply__like-btn'
									: 'comment-reply__like-btn-active'
							"
							@click="handleLikeComment(comment)"
						>
							<Icon
								type="hearth"
								:color="isCurrentUserLike ? 'var(--text_button_tint)' : '#9b9b9b'"
								:size="24"
								:pr="6"
							/>
							<span>
								{{ upvoteCount }}
							</span>
						</span>
						<span class="comment-reply__replies-count ml-4">
							<Icon type="comment" color="#9b9b9b" :size="24" :pr="6" />
							<span class="comment-reply__replies-count-num">
								{{ repliesCount }}
							</span>
						</span>
					</div>

					<div class="reply_buttons">
						<button
							v-if="!isReply"
							class="comment-reply__button px-0 ml-4"
							@click="replyHandler"
							v-ripple="false"
						>
							Reply
						</button>
					</div>
				</div>
				<v-divider />

				<ReplyCommentForm
					v-if="isReply"
					:comment="comment"
					:post="post"
					:parent="parentComment"
					:autoMentionUser="comment.user"
					v-click-outside="hideInput"
					:isReply="isReply"
					@success="successReply"
					:class="{ 'comment-card__reply-last': replies.length === 0 }"
				/>
				<div v-if="level < 2">
					<Reply
						v-for="reply in replies"
						:reply-on-reply="true"
						:key="reply.id"
						:comment="reply"
						:post="{
							thread_id: reply.threadId,
							user: reply.user,
						}"
						:level="level + 1"
						:parent-comment="comment"
					/>
				</div>
			</div>
		</div>
		<div v-if="level >= 2">
			<Reply
				class="mb-5 mt-5 comment-reply-low-level"
				v-for="reply in replies"
				:reply-on-reply="true"
				:key="reply.id"
				:comment="reply"
				:post="{
					thread_id: reply.threadId,
					user: reply.user,
				}"
				:level="level + 1"
				:parent-comment="comment"
			/>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Avatar from '@/components/Avatar'
import CommentEditForm from '@/components/Forms/CommentEditForm'
import ReplyCommentForm from '@/components/Forms/ReplyCommentForm'
import { normalizeComment } from '@/utils/helpers'

import likedIcon from '@/assets/images/postIcon/icon-liked.svg'
import likeIcon from '@/assets/images/postIcon/icon-like.svg'

export default {
	name: 'Reply',
	props: {
		comment: {
			type: Object,
			default: () => ({}),
		},
		replyOnReply: {
			type: Boolean,
			default: false,
		},
		parentComment: {
			type: Object,
			default: () => ({}),
		},
		post: {
			type: Object,
			default: () => ({}),
		},
		level: {
			type: Number,
			default: 0,
		},
	},
	components: {
		Avatar,
		CommentEditForm,
		ReplyCommentForm,
	},
	data() {
		return {
			isReply: false,
			isEdit: false,
			isLike: false,
			likedIcon,
			likeIcon,
			isModal: false,
		}
	},
	methods: {
		...mapActions('post', ['deleteComment', 'likeComment']),
		...mapActions('forum', ['setActiveComment']),
		closeModal() {
			this.isModal = false
		},
		openDeleteModal() {
			this.isModal = !this.isModal
		},
		toggleToUser() {
			const isOwn = this.isCurrentUser(this.comment.user.user_id)
			return this.$router.push({
				name: isOwn ? 'profile' : 'user-by-id',
				params: isOwn ? {} : { id: this.comment.user.user_id },
			})
		},
		hideInput() {
			if (this.isReply) {
				this.setActiveComment(false)
			}
			this.isReply = false
		},
		hideEditInput() {
			this.isEdit = false
			this.setActiveComment(this.isEdit)
		},
		successReply() {
			this.isReply = false
			this.setActiveComment(this.isReply)
		},
		replyHandler() {
			this.inputFocus = true
			if (!this.isReply) {
				this.setActiveComment(true)
			}
			this.isReply = true
		},
		handleDeleteComment(comment) {
			this.deleteComment(comment)
			this.isModal = false
		},
		handleLikeComment(comment) {
			this.likeComment(comment)
		},
		isCurrentUser(userId) {
			if (!this.profile) {
				return false
			}

			const { user_id: currentUserId } = this.profile

			return userId === currentUserId
		},
		contentFormateChangeMentions(content) {
			const pattern = /@\[\d+\|[^]+?\]/g
			const matches = content.match(pattern)

			let result = content

			if (matches) {
				for (let i = 0; i < matches.length; i++) {
					const user_name = matches[i].match(/\|(.+?)\]/)[1]
					const user_id = matches[i].match(/@\[(\d+)\|/)[1]
					const replacement = `<a class="text-decoration-none" href="${process.env.VUE_APP_PUBLIC_PATH}user/${user_id}"><span>@${user_name}</span></a>`

					result = result.replace(matches[i], replacement)
				}
			}

			return result
		},
	},
	computed: {
		...mapGetters('auth', ['isAuthenticated', 'profile']),

		replies() {
			return this.comment.replies.map((item) => normalizeComment(item)).reverse()
		},
		isCurrentUserLike() {
			return !!this.comment.upvote
		},
		upvoteCount() {
			return this.comment.upvoteCount || 0
		},
		repliesCount() {
			return this.comment.replies.length
		},
		isOwnCurrentUserComment() {
			return this.comment.userId === this.profile.user_id
		},
		hostName() {
			return window.location.hostname || 'localhost'
		},
		protocol() {
			return window.location.protocol || 'http'
		},
		dateCreated() {
			const date = new Date(this.comment.date)
			const options = { year: 'numeric', month: 'long', day: 'numeric' }
			return date.toLocaleDateString('en-US', options)
		},
	},
}
</script>

<style lang="scss">
.reply_buttons {
	display: flex;
	align-items: center;
}

.v-card {
	&__actions {
		align-items: flex-start;
	}
}

.comment-card {
	&__link {
		color: var(--username-category-title) !important;
	}
	&__user-name {
		color: var(--username-category-title);
		font-family: Inter, sans-serif;
		font-weight: 700;
		font-size: 18px;
		line-height: 100%;
		letter-spacing: 0;
		white-space: nowrap;
	}
	&__user-profile-row {
		font-family: Inter, sans-serif;
		font-weight: 400;
		font-size: 15px;
		line-height: 20px;
		letter-spacing: 0;
		color: var(--company-position-large) !important;
	}
	&__likes-box {
		display: flex;
		justify-content: space-between;
		padding: 12px 12px 12px 36px;
	}
}

.comment-reply {
	padding-top: 12px;
	background-color: #f3f3f6 !important;
	&__info-box {
		width: 100%;
	}
	&__title-box {
		display: flex;
		width: 100%;
	}
	&__user-info-container {
		display: flex;
		height: 46px;
		flex-direction: column;
		justify-content: space-between;
	}
	@media (max-width: 480px) {
		margin-left: 30px;
	}

	&__avatar {
		border-radius: 8px;
	}

	&__title {
		font-style: normal;
		font-weight: 700;
		font-size: 16px;
		line-height: 20px;
		color: #41a0d8;
	}

	&__subtitle {
		max-width: 364px;
		width: 100%;
		color: var(--company-position-large);
	}

	&__content {
		font-family: Inter, sans-serif;
		font-weight: 500;
		font-size: 16px;
		line-height: 100%;
		letter-spacing: 0;

		& span {
			font-weight: bold;
			color: #42a0d8;
			cursor: pointer;
		}
	}

	&__button {
		font-family: Inter, sans-serif;
		font-weight: 700;
		font-size: 14px;
		line-height: 100%;
		letter-spacing: 0;
		text-align: center;
		color: #0055a3;
	}

	&__like-btn,
	&__like-btn-active {
		font-family: 'Inter', sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 13px;
		height: 16px;
		line-height: 16px;
		cursor: pointer;
		display: flex;
		align-items: center;
		user-select: none;
	}

	&__like-btn {
		i,
		span {
			color: var(--text_button_tint) !important;
		}

		&-active {
			i,
			span {
				color: #a0a0a0 !important;
			}
		}
	}

	&__replies-count {
		display: flex;
		align-items: center;

		&-icon {
			color: var(--accent-color) !important;
			position: relative;
			top: 2px;
		}

		&-num {
			color: #9b9b9b;
			font-family: Inter, sans-serif;
			font-weight: 700;
			font-size: 13px;
			line-height: 100%;
			letter-spacing: 0;
		}
	}

	&__date {
		color: #9b9b9b;
		font-family: Inter, sans-serif;
		font-weight: 400;
		font-size: 13px;
		line-height: 100%;
		letter-spacing: 0px;
		text-align: right;
	}

	@media screen and (max-width: 768px) {
		&__outer-box {
			flex-direction: column;
		}
		&__info-box {
			width: 100%;
		}
	}
}

.comment-reply-low-level {
	border: none;
	padding-left: 0;
}
</style>
